import { Outlet, useLocation } from "react-router-dom";
import * as React from "react";
import "./Home.scss";
import { useNavigate } from "react-router-dom";
import ProfileComponent from "../Profile/ProfileComponent";
import { logout } from "../../services/authService";
import { useState } from "react";
import LoginResetPassword from "../LoginResetPassword/LoginResetPassword";
import SideNav from "../../layouts/sidenav/SideNav";
import Header from "../../layouts/Header/Header";
import { useDispatch } from "react-redux";
import { setToken } from "../../actions/authActions";
import AppAuthSetup from "../AppAuth/AppAuthSetup";

const Home = (props: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  let { checkSubscriptionDialogOnRouteChange } = props;
  const initState = {
    profile: false,
    resetPassword: false,
    appAuthSetup: false,
    appAuthEdit: false,
  };
  const email = JSON.parse(localStorage.getItem("user") || "{}")?.email;
  const [profileOpen, setProfileOpen] = useState(true);
  const [menutabs, setMenutabs] = useState(initState);

  const logoutAction = () => {
    logout().then(() => {
      dispatch(setToken(null));
      navigate("/auth/login");
    });
  };
  const headerMenuAction = (data: any) => {
    //  if(data.type === "profile"){
    setMenutabs({ ...initState, [data.type]: true });
    //}
  };

  const closeProfile = () => {
    setProfileOpen(false);
    setMenutabs({ ...initState, profile: false });
  };

  const closeResetPassword = () => {
    setProfileOpen(false);
    setMenutabs({ ...initState, resetPassword: false });
  };

  const closeAppAuthSetup = () => {
    setMenutabs({ ...initState, appAuthSetup: false, appAuthEdit: false });
  };

  React.useEffect(() => {
    checkSubscriptionDialogOnRouteChange();
  }, [location.pathname]);

  return (
    <React.Fragment>
      {menutabs.profile ? (
        <ProfileComponent open={menutabs.profile} onClose={closeProfile} />
      ) : (
        ""
      )}
      {menutabs.resetPassword ? (
        <LoginResetPassword
          open={menutabs.resetPassword}
          onClose={closeResetPassword}
        />
      ) : (
        ""
      )}
      {menutabs.appAuthSetup || menutabs.appAuthEdit ? (
        <AppAuthSetup
          email={email}
          open={menutabs.appAuthSetup || menutabs.appAuthEdit}
          onClose={closeAppAuthSetup}
          fromLogin={false}
          isEdit={menutabs.appAuthEdit}
        />
      ) : (
        ""
      )}
      <div className="flex flex-row  h-100v w-100v overflow-x-hidden">
        <SideNav />
        <div className="flex flex-col w-full overflow-hidden bg-neutral-50">
          {localStorage.getItem("token") || true ? (
            <Header
              logoutAction={logoutAction}
              headerMenuAction={headerMenuAction}
            />
          ) : (
            ""
          )}
          <Outlet context={[logoutAction]} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default Home;
